import { render, staticRenderFns } from "./balance-add.vue?vue&type=template&id=32096734&scoped=true"
import script from "./balance-add.vue?vue&type=script&lang=js"
export * from "./balance-add.vue?vue&type=script&lang=js"
import style0 from "./balance-add.vue?vue&type=style&index=0&id=32096734&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32096734",
  null
  
)

export default component.exports